import { Component, Input, SimpleChanges } from '@angular/core';
import { DocumentMetadata, MetadataType } from 'src/app/models/documentMetadata';

@Component({
  selector: 'app-document-order-possibility',
  templateUrl: './document-order-possibility.component.html',
  styleUrls: ['./document-order-possibility.component.scss']
})
export class DocumentOrderPossibilityComponent {
  @Input() metadata?: DocumentMetadata[] = [];
  @Input() possibility?: boolean;
  confidence: number = 0;

  constructor(
  ) {
  }

  ngOnInit(): void {
    this.populateConfidence()
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.populateConfidence()
  }

  populateConfidence() {
    this.confidence = this.getConfidence();
  }


  getConfidence() {
    return (this.metadata?.find(datum => datum.type === MetadataType.STORE_ORDER_POSSIBILITY && this.possibility !== undefined && datum.value.toLowerCase() === this.possibility.toString())?.confidence ?? 0) * 100
  }

}
